// extracted by mini-css-extract-plugin
export var quillEditor = "_jv-1";
export var variable = "_jv-0";